export const buildWwwHeartbeatOrEmpty = (data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    if (!data) {
        return {
            _id: '',
            _type: 'heartbeatData',
            _createdAt: '',
            _updatedAt: '',
            _rev: '',
            country: '',
            countryCode: '',
            regionName: '',
            region: '',
            city: '',
            currency: '',
            csrfToken: '',
            ip: '',
            now: Date.now(),
            lastFetched: undefined,
        };
    }
    return {
        _id: (_a = data._id) !== null && _a !== void 0 ? _a : '',
        _type: 'heartbeatData',
        _createdAt: (_b = data._createdAt) !== null && _b !== void 0 ? _b : '',
        _updatedAt: (_c = data._updatedAt) !== null && _c !== void 0 ? _c : '',
        _rev: (_d = data._rev) !== null && _d !== void 0 ? _d : '',
        country: (_e = data.country) !== null && _e !== void 0 ? _e : '',
        countryCode: (_f = data.countryCode) !== null && _f !== void 0 ? _f : '',
        regionName: (_g = data.regionName) !== null && _g !== void 0 ? _g : '',
        region: (_h = data.region) !== null && _h !== void 0 ? _h : '',
        city: (_j = data.city) !== null && _j !== void 0 ? _j : '',
        currency: (_k = data.currency) !== null && _k !== void 0 ? _k : '',
        csrfToken: (_l = data.csrfToken) !== null && _l !== void 0 ? _l : '',
        ip: (_m = data.ip) !== null && _m !== void 0 ? _m : '',
        now: (_o = data.now) !== null && _o !== void 0 ? _o : Date.now(),
        lastFetched: (_p = data.lastFetched) !== null && _p !== void 0 ? _p : undefined,
    };
};
